// extracted by mini-css-extract-plugin
module.exports = {"helsinkiCityOwnedText":"eventName_helsinkiCityOwnedText__UUayS","eventCancelled":"eventName_eventCancelled__gLjOA"};